/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Attribute } from './attribute';
import { BusinessObjectFormatKey } from './businessObjectFormatKey';


export interface UploadSingleInitiationRequest { 
    sourceBusinessObjectFormatKey: BusinessObjectFormatKey;
    targetBusinessObjectFormatKey: BusinessObjectFormatKey;
    /**
     * The business object data attributes
     */
    businessObjectDataAttributes?: Array<Attribute>;
    file: Blob;
    /**
     * The target storage name to move the encrypted file to
     */
    targetStorageName?: string;
}
